<template>
  <v-container
    class="fill-height darkBlue"
    fluid
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="4"
      >
        <v-card class="elevation-12">
          <div class="pa-10">
            <v-img src="../assets/PreventiaLogoSmall.png" maxHeight="130" contain />
          </div>
          <v-card-actions class="d-flex justify-center mb-10">
            <v-btn rounded color="lightBlue" @click="redirectToClientUI">
              Login
            </v-btn>
          </v-card-actions>
          <!-- todo disable login form only path to login is through sso from client app -->
          <!-- <template v-if="showForm === 'login'">
            <v-card-text>
              <alerts
                alertGroup="login"
              />
              <ValidationObserver ref="loginForm">
                <v-form>
                  <ValidationProvider name="Email" rules="required|email" v-slot="{ errors }">
                    <v-text-field
                      v-model="username"
                      :errorMessages="errors"
                      label="Email"
                      name="username"
                      prependIcon="mdi-account"
                      type="text"
                      required
                    />
                  </ValidationProvider>

                  <ValidationProvider name="Password" rules="required" v-slot="{ errors }">
                    <v-text-field
                      v-model="password"
                      id="password"
                      :errorMessages="errors"
                      label="Password"
                      name="password"
                      prependIcon="mdi-lock"
                      :appendIcon="show ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="show ? 'text' : 'password'"
                      @click:append="show = !show"
                    />
                    <div class="d-flex justify-end">
                      <v-btn
                        small
                        text
                        color="grey"
                        class="no-text-transform"
                        @click="showForm = 'forgotPassword'"
                      >
                        Forgot password?
                      </v-btn>
                    </div>
                  </ValidationProvider>
                </v-form>
              </ValidationObserver>
            </v-card-text>
            <v-card-actions class="d-flex justify-end">
              <v-btn rounded color="lightBlue" :loading="loginIn" @click="login">
                Login
              </v-btn>
            </v-card-actions>
          </template>

          <template v-else>
            <v-card-title class="d-flex justify-center">{{ showForm === 'forgotPassword' ? 'Forgot Password?' : 'Register' }}</v-card-title>
            <v-card-subtitle v-if="showForm === 'forgotPassword'" class="text-center">Please enter your email address and we will send you instructions on how to reset your password</v-card-subtitle>

            <v-card-text>
              <alerts
                alertGroup="login"
              />
              <ValidationObserver ref="resetPasswordForm">
                <v-form>
                  <ValidationProvider name="Email" rules="required|email" v-slot="{ errors }">
                    <v-text-field
                      v-model="username"
                      :errorMessages="errors"
                      label="Email"
                      name="username"
                      prependIcon="mdi-account"
                      type="text"
                      required
                    />
                  </ValidationProvider>
                </v-form>
              </ValidationObserver>
            </v-card-text>
            <v-card-actions>
              <v-btn
                text
                @click="showForm = 'login'"
              >
                Cancel
              </v-btn>
              <v-spacer />
              <v-btn rounded color="lightBlue" :loading="resetingPassword" @click="resetPassword">
                {{ showForm === 'forgotPassword' ? 'Reset Password' : 'Register' }}
              </v-btn>
            </v-card-actions>
          </template> -->
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { CLIENT_APP_URL } from '../helpers/apiUtilities';
export default {
  name: 'TheLogin',
  data: function () {
    return {
      show: false,
      username: '',
      password: '',
      showForm: 'login',
      resetingPassword: false,
      loginIn: false
    };
  },
  methods: {
    redirectToClientUI: function () {
      window.open(CLIENT_APP_URL, '_self');
    },
    login: async function (event) {
      const isValid = await this.$refs.loginForm.validate();

      if (isValid) {
        this.loginIn = true;
        this.$store.dispatch('login', {
          username: this.username,
          password: this.password
        }).then((success) => {
          this.loginIn = false;
          if (success) {
            const nextUrl = this.$route.query?.redirect;
            if (nextUrl) {
              this.$router.push(nextUrl);
            } else {
              this.$router.push('/');
            }
          }
        });
      }
    },
    resetPassword: async function () {
      const isValid = await this.$refs.resetPasswordForm.validate();

      if (isValid) {
        this.resetingPassword = true;
        this.$store.dispatch('resetPassword', this.username)
          .then(() => {
            this.resetingPassword = false;
          });
      }
    }
  }
};
</script>
